import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter, Route, Switch} from 'react-router-dom';
import App from '../containers/App';
import OnBoarding from '../containers/Onboarding/OnBoarding';
import NavTabs from '../containers/NavTabs/NavTabs';
//import { camelCase } from 'lodash';

const styles = theme => ({
  root: {
    backgroundColor: '#B71C1C',
    borderRadius: 3,
    padding: '2px',
    margin:'3px'
  },
  rootWithAward: {
    backgroundColor: '#B71C1C',
    borderRadius: 3,
    padding: '2px',
    margin:'3px',
    borderTop: '3px solid #FFFFFF', // White line at top for delivered awards
    borderBottom: '3px solid #FFD700', // Gold underline for delivered awards
  },
  listItemText: {
    textAlign: 'center',
    width: '100%',
    padding: '2px',
    margin:'3px',
    color: 'white',
    
  },
  listItemSecondary: {
    textAlign: 'center',
    color: 'rgba(255,255,255,0.75)',
    fontSize: '0.75rem',
  },
  link: {
    textDecoration: 'none',
  },
});

const CaseItemLink = (props) => {
    const {classes, primary } = props;
    const hasAwardDelivered = primary.awardDelivered === true;
    
    return (
      <div style={{padding:'3px'}}>
        <Link to={`${props.match.path}/${primary.caseId}`} className={classes.link}>
          <ListItem button classes={{ root: hasAwardDelivered ? classes.root : classes.root }} >
            <ListItemText 
              primary={`Case ${primary.caseId}`} 
              // secondary={primary.claimantName ? primary.claimantName : ''}
              classes={{primary:classes.listItemText, secondary:classes.listItemSecondary}}
            />
          </ListItem>
        </Link>
      </div>
      
    );
}

CaseItemLink.propTypes = {
    primary: PropTypes.node.isRequired,
};

export default withStyles(styles)(withRouter(CaseItemLink));